// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IOrderDelivery } from '@/models/orders.model';

// Helpers
import { getOrderDeliveryDetailsData } from '../../helpers';

interface IDeliveryDetailsBlockProps {
  deliveryData: IOrderDelivery;
}

const DeliveryDetailsBlock = ({ deliveryData }: IDeliveryDetailsBlockProps) => {
  const { t } = useTranslation(['orders']);
  const contentList = getOrderDeliveryDetailsData(t, deliveryData);

  return <>{contentList.map((el, index) => (index === contentList.length - 1 ? el : `${el}, `))}</>;
};

export default DeliveryDetailsBlock;
